import React from "react";
import Icon from "components/ui/Icon";
import { ButtonLevel, ButtonLink, ButtonSize } from "components/ui/Button";
import { colors } from "utils/theme";
import * as Styled from "./styled";
import { LinkButton } from "../Link";
import UILabel from "../UILabel";
import { NAVIGATION } from "./constants";
import { getPath } from "./utils";
import ExportDataButton from "./ExportDataButton";

interface Props {
  isOpen: boolean;
  closeDrawer: () => void;
}

const MobileLinks: React.FC<Props> = ({ isOpen, closeDrawer }) => (
  <Styled.MobileLinks $isOpen={isOpen}>
    <Styled.ButtonsWrapper>
      <ExportDataButton level={ButtonLevel.cta} />

      <ButtonLink
        href="/dashboard"
        size={ButtonSize.md}
        level={ButtonLevel.ghost}
      >
        Dashboard
      </ButtonLink>
    </Styled.ButtonsWrapper>

    <Styled.MobileNavItems>
      {NAVIGATION.filter((item) => item.hideMobile).map((item) => (
        <Styled.NavItem key={item.title}>
          <Styled.NavLink to={getPath(item.path)} end>
            <Icon name={item.icon} color={colors.violet} />
            <Styled.Label>{item.title}</Styled.Label>
          </Styled.NavLink>
        </Styled.NavItem>
      ))}
    </Styled.MobileNavItems>

    <Styled.MobileCloseButton>
      <LinkButton onClick={closeDrawer}>
        <Icon name="close" />
        <UILabel.Small bold>Close</UILabel.Small>
      </LinkButton>
    </Styled.MobileCloseButton>
  </Styled.MobileLinks>
);

export default MobileLinks;
